import React from "react";
import { Card } from "antd";

const TermsAndConditions: React.FC = () => {
  return (
    <div dir="rtl" className="max-w-4xl mx-auto p-4 text-right space-y-6">
      <Card className="shadow-lg rounded-2xl">
        <h1 className="text-2xl font-bold mb-4 text-blue-700">
          الشروط والأحكام
        </h1>
        <p>مرحبًا بك في موقع حجوزاتي! 🎉</p>
        <p>
          يرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام الموقع. بدخولك إلى
          الموقع أو استخدام أي من خدماته، فإنك توافق على الالتزام بهذه الشروط.
          إذا لم توافق على أي جزء منها، يُرجى عدم استخدام الموقع.
        </p>

        <div className="space-y-4 mt-6">
          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              1. التعريفات:
            </h2>
            <p>
              <strong>"الموقع":</strong> يُقصد به موقع حجوزاتي الإلكتروني.
            </p>
            <p>
              <strong>"المستخدم":</strong> أي شخص يقوم بزيارة أو استخدام الموقع.
            </p>
            <p>
              <strong>"الخدمات":</strong> تشمل كافة خدمات الحجز المقدمة من خلال
              الموقع.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              2. استخدام الموقع:
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>
                يجب أن يكون عمرك 18 سنة أو أكثر أو أن تستخدم الموقع بإشراف ولي
                الأمر.
              </li>
              <li>
                تلتزم باستخدام الموقع للأغراض المشروعة فقط وبطريقة لا تنتهك
                القوانين أو حقوق الآخرين.
              </li>
              <li>
                نحتفظ بالحق في تعليق أو إنهاء حسابك في حال تم انتهاك الشروط.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              3. الحجز والدفع:
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>يتم تأكيد الحجز فقط بعد إتمام عملية الدفع بنجاح.</li>
              <li>
                الأسعار قابلة للتغيير دون إشعار مسبق، إلا في حال تم تثبيت السعر
                أثناء عملية الحجز.
              </li>
              <li>جميع عمليات الدفع تتم من خلال بوابات دفع آمنة ومعتمدة.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              4. سياسة الإلغاء والاسترداد:
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>
                تختلف سياسة الإلغاء والاسترداد حسب نوع الخدمة أو مزوّد الحجز،
                وسيتم توضيحها أثناء الحجز.
              </li>
              <li>
                في بعض الحالات، قد لا يكون هناك إمكانية للاسترداد (مثلاً حجوزات
                اللحظة الأخيرة أو العروض الخاصة).
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              5. المسؤولية:
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>
                نحن نعمل كوسيط بينك وبين مزودي الخدمة (فنادق، مواصلات،
                فعاليات...)، ولا نتحمل مسؤولية أي خلل أو خطأ ناتج عن الطرف
                الثالث.
              </li>
              <li>
                الموقع غير مسؤول عن أي تأخير أو إلغاء من قِبل مزود الخدمة.
              </li>
              <li>أنت المسؤول عن التأكد من صحة البيانات المدخلة عند الحجز.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              6. المحتوى والملكية الفكرية:
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>
                جميع الحقوق محفوظة لموقع حجوزاتي، ويمنع إعادة استخدام أي محتوى
                (نصوص، صور، شعارات...) دون إذن مكتوب.
              </li>
              <li>يحق للموقع تعديل أو حذف أي محتوى في أي وقت دون إشعار.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              7. الخصوصية:
            </h2>
            <p>باستخدام الموقع، فإنك توافق على سياسة الخصوصية الخاصة بنا.</p>
            <p>
              للمزيد من التفاصيل، يرجى مراجعة سياسة الخصوصية الخاصة بالموقع.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              8. التعديلات:
            </h2>
            <p>نحتفظ بحقنا في تعديل هذه الشروط والأحكام في أي وقت.</p>
            <p>
              سيتم إشعار المستخدمين بأي تعديلات من خلال الموقع، واستمرارك في
              استخدام الموقع بعد التعديلات يعتبر موافقة منك.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              9. القانون المعمول به:
            </h2>
            <p>
              تخضع هذه الشروط وتُفسر وفقًا للقوانين المعمول بها في [اكتب اسم
              الدولة أو المدينة].
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-blue-600">
              10. التواصل معنا:
            </h2>
            <p>
              📧 لأي استفسار أو دعم، تواصل معنا عبر البريد الإلكتروني: [ضع
              الإيميل هنا]
            </p>
            <p>📞 أو اتصل على الرقم: [ضع رقم الدعم]</p>
          </section>

          <p className="mt-6 font-medium text-blue-700">
            شكراً لاستخدامك حجوزاتي! 💙
            <br />
            نتمنى لك تجربة حجز مريحة وسهلة!
          </p>
        </div>
      </Card>
    </div>
  );
};

export default TermsAndConditions;
